import { render, staticRenderFns } from "./my-table.vue?vue&type=template&id=018c379b&scoped=true&"
import script from "./my-table.vue?vue&type=script&lang=js&"
export * from "./my-table.vue?vue&type=script&lang=js&"
import style0 from "./my-table.vue?vue&type=style&index=0&id=018c379b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c379b",
  null
  
)

export default component.exports